import { render } from "./TransitionA11y.vue?vue&type=template&id=35cefc0a"
import script from "./TransitionA11y.vue?vue&type=script&lang=js"
export * from "./TransitionA11y.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__